import getExtensionEventByType from "./getExtensionEventByType";
import type { IAddinCommand } from "owa-addins-types";
import type { MailboxInfo } from "owa-client-types";
import type ExtensionEventType from "owa-service/lib/contract/ExtensionEventType";
/**
 * Checks if any "ItemSend" add-in is installed for the given mailbox.
 *
 * This function retrieves the list of add-ins associated with the "ItemSend" event type
 * for the specified mailbox and determines if there are any installed add-ins.
 *
 * @param mailboxInfo - The mailbox information used to retrieve the add-ins.
 * @returns A boolean value indicating whether at least one "ItemSend" add-in is installed.
 */
export function isAnyItemSendAddinInstalled(mailboxInfo: MailboxInfo): boolean {
    const itemSendAddinList: IAddinCommand[] = getExtensionEventByType(1, mailboxInfo);
    return !!itemSendAddinList && itemSendAddinList.length > 0;
}
